module.exports = __webpack_public_path__ + "static/media/icn-53-labor.7de070c5.svg";